<template>
  <b-modal @shown="getCompreende" :size="legenda ? 'md' : 'xl'" id="ModalCompreende" hide-footer>
    <Header
      :titulo="legenda ? 'CNAE X NCM' : cnae ? cnae.label : ''"
      :close="closeModalCnaeCompreende"
      slot="modal-header"
    />
    <div class="modal-compreende-corpo">
      <div v-if="!legenda">
        <div v-if="loading" class="loading-compreende">
          <LoadingPadraoContainer
            :fraseLoading="['Aguarde um momento', 'Procurando dados']"
            delay="5000"
            classe="azul"
          />
        </div>
        <div v-if="compreende" class="compreende-container">
          <BlocoCompreende titulo="Compreende:" :conteudo="compreende.compreende" />
          <BlocoCompreende titulo="Não Compreende:" :conteudo="compreende.nao_compreende" />
        </div>
      </div>
      <Header
        v-if="!legenda"
        class="modal-header-secundario-compreende"
        secundario
        titulo="CNAE X NCM"
      />
      <LegendaCompreende :legenda="legenda" />
    </div>
  </b-modal>
</template>

<script>
import Api from "@/services/api.js";
import BlocoCompreende from "./BlocoCompreende.vue";
import LegendaCompreende from "./LegendaCompreende.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ModalCompreende",
  components: {
    BlocoCompreende,
    LegendaCompreende,
    Header,
    LoadingPadraoContainer
  },
  props: {
    cnae: Object,
    legenda: Boolean
  },
  data() {
    return {
      compreende: null,
      loading: false,
      cnaeIdBackup: false
    };
  },
  methods: {
    closeModalCnaeCompreende() {
      this.$root.$emit("bv::hide::modal", "ModalCompreende");
    },
    async getCompreende() {
      // if (this.legenda) return;
      if (this.legenda || this.cnae.value == this.cnaeIdBackup) return;
      this.compreende = null;
      this.loading = true;
      let response = await new Api().get(`Cnae/obterCompreende/${this.cnae.value}`);
      [this.compreende] = response.dados;
      this.cnaeIdBackup = this.cnae.value;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.compreende-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 30px;
  margin-bottom: 10px;
  overflow: auto;
  max-height: calc(100vh - 330px);
}
.modal-compreende-corpo {
  width: 100%;
  min-height: 50px;
}
.loading-compreende {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% + 28px);
  // height: 100%;
  height: 70px;
  // position: absolute;
  // top: 0;
  // left: 0;
  z-index: 1000;
  margin: -14px 0 0 -14px;
  // margin-bottom: 0;
  background: #00000033;
  color: var(--branco);
  font-size: 40px;
}
.modal-header-secundario-compreende {
  margin-bottom: 14px;
}
</style>
